<template>
  <div class="invoice-payment-result__wrapper">
    <a-t-loader v-if="isInvoicePayments"/>

    <template v-else>
      <div class="main-content">
        <div class="container-lg">
          <div class="invoice-payment-result">
            <div class="modal-wrapper">
              <div class="modal-backdrop"></div>
              <div class="modal-inner" style="align-items: flex-start;">
                  <div class="edit-popup edit-popup--invoice-total-amount">
                    <div v-if="resultPayment.payment === 'failure'" class="result-card">
                      <div class="title">
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="15" cy="15" r="15" fill="#F13C3C"/>
                          <circle cx="15" cy="15" r="12" stroke="white" stroke-width="2"/>
                          <g clip-path="url(#clip0_4917_4790)">
                            <path d="M21.876 18.8091L15.7939 8.27294C15.4414 7.66244 14.5586 7.66244 14.2061 8.27294L8.12397 18.8091C7.77143 19.4196 8.21283 20.1849 8.91791 20.1849H21.0821C21.7872 20.1849 22.2286 19.4196 21.876 18.8091ZM15.0086 11.5175C15.3984 11.5175 15.7137 11.8414 15.7022 12.2312L15.5876 16.2324C15.579 16.5477 15.321 16.797 15.0057 16.797C14.6904 16.797 14.4325 16.5448 14.4239 16.2324L14.3121 12.2312C14.3035 11.8414 14.6159 11.5175 15.0086 11.5175ZM15 18.7546C14.6016 18.7546 14.2777 18.4308 14.2777 18.0324C14.2777 17.634 14.6016 17.3101 15 17.3101C15.3984 17.3101 15.7223 17.634 15.7223 18.0324C15.7223 18.4308 15.3984 18.7546 15 18.7546Z" fill="white"/>
                          </g>
                          <defs>
                            <clipPath id="clip0_4917_4790">
                              <rect width="14" height="14" fill="white" transform="translate(8 7)"/>
                            </clipPath>
                          </defs>
                        </svg>
                        <span>Payment is failed</span>
                      </div>
                      <div class="desc">
                        <span>Sorry, something went wrong. Please contact your tour manager.</span>
                      </div>
                      <div class="btn">
                        <router-link class="btn btn--green" :to="{ name: 'invoice-shared', params: { link: currentInvoice.link }}">
                          <span>Ok, got it!</span>
                        </router-link>
                      </div>
                    </div>
                    <div v-if="resultPayment.payment === 'success'" class="result-card">
                      <div class="title">
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="15" cy="15" r="15" fill="#77B017"/>
                          <path d="M13.595 19.8266C13.4805 19.9379 13.3242 20 13.1619 20C12.9995 20 12.8432 19.9379 12.7287 19.8266L9.26926 16.4847C8.91025 16.1379 8.91025 15.5756 9.26926 15.2295L9.70243 14.811C10.0616 14.4642 10.643 14.4642 11.0021 14.811L13.1619 16.8972L18.9979 11.2601C19.3571 10.9133 19.9391 10.9133 20.2976 11.2601L20.7307 11.6786C21.0898 12.0253 21.0898 12.5875 20.7307 12.9338L13.595 19.8266Z" fill="white"/>
                          <circle cx="15" cy="15" r="12" stroke="white" stroke-width="2"/>
                        </svg>
                        <span>Successful Payment</span>
                      </div>
                      <div class="desc">
                        <span>Thank you for the payment, our manager will contact you when we receive the payment.</span>
                      </div>
                      <div class="btn">
                        <router-link class="btn btn--green" to="/">
                          <span>Thank you!</span>
                        </router-link>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import Vuex from 'vuex'
import ATLoader from "@/components/Loaders/Loader";
import {actionTypes} from "@/store/modules/invoices";
export default {
  name: 'AtInvoicePaymentResult',
  data(){
    return {
      isInvoicePayments: true
    }
  },
  components: {ATLoader},
  computed: {
    resultPayment() {
      let vm = this
      return vm.$route.query
    },
  },
  methods: {
    ...Vuex.mapActions({
      getInvoiceShared: actionTypes.getInvoiceShared
    }),

    findInvoiceShared(link) {
      this.getInvoiceShared({
        link: link,
      }).then((res) => {
        // console.log('RESULT', res.data)
        this.currentInvoice = res.data
        // console.log('currentInvoice ID', this.currentInvoice.id)

        this.isInvoicePayments = false
      })
    },
  },
  mounted() {
    // console.log(this.$route.query.payment)
    // console.log(this.$route.params.link)
    // console.log(window.location.pathname.includes('invoice/payment/result'))
    if (this.$route.params.link) this.findInvoiceShared(this.$route.params.link)
  }
}
</script>

<style lang="scss" scoped>
.invoice-payment-result {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .modal-wrapper {
    .modal-inner {
      padding: 25rem;
      .result-card {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .title {
          display: flex;
          align-items: center;

          padding-bottom: 20px;
          span {
            padding-left: 10px;
            font-weight: 500;
            font-size: 14px;
            line-height: 17px;
            text-align: center;

            color: #0C0C0C;
          }
        }
        .desc {
          text-align: center;

          padding-bottom: 20px;
          span {
            font-weight: 400;
            font-size: 13px;
            line-height: 16px;
            text-align: center;

            color: #0C0C0C;
          }
        }
      }
    }
  }
}
</style>
